import { Avatar, Box, Typography } from "@mui/material";
import { FilePenLine } from "lucide-react";
import { Invoice_InvoiceChangeEvents } from "protogen/billing_service_pb";
import useIsMobile from "components/hooks/useIsMobile";
import DateDisplay from "components/common/DateDisplay";

const BillingAvatar = () => {
  return (
    <Box
      sx={{
        height: "inherit",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
        width: "40px",
      }}
    >
      <Avatar
        sx={{
          background: "#F2F4F7",
          color: "#475467",
          textAlign: "center",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "28px",
        }}
      >
        <FilePenLine />
      </Avatar>
    </Box>
  );
};

export default ({
  changeEvent,
}: {
  changeEvent: Invoice_InvoiceChangeEvents;
}) => {
  const isMobile = useIsMobile();
  const eventData = JSON.parse(changeEvent.eventJson);
  const regex = /^\[(.+)\s*,\s*(.+)\]$/;

  const changedKeys: string[] = Object.keys(eventData).filter(
    (key) => typeof eventData[key] === "string" && eventData[key].match(regex),
  );

  return (
    <Box
      sx={{
        display: "flex",
        gap: "12px",
        flexGrow: 1,
      }}
    >
      {!isMobile && <BillingAvatar />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#FAF9FA",
          flexGrow: 1,
          borderRadius: "16px",
          padding: "16px 24px",
          gap: "8px",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexGrow: 1,
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography sx={{ fontWeight: "700" }}>Invoice Edited</Typography>
          </Box>
          <Box sx={{ display: "flex", gap: "4px", flexDirection: "column" }}>
            <DateDisplay
              date={
                new Date(
                  eventData["timestamp"] +
                    (eventData["timestamp"].endsWith("Z") ? "" : "Z"),
                )
              }
              sx={{ fontSize: "14px", color: "#6B6E7B" }}
            />
          </Box>
        </Box>
        <Box>
          {eventData["change_notes"] && (
            <Typography sx={{ color: "text.secondary" }}>
              {eventData["change_notes"] || "N/A"}
            </Typography>
          )}
          {changedKeys.map((k) => (
            <Box
              key={k}
              sx={{
                mt: 2,
                mb: 1,
                p: 2,
                borderRadius: "8px",
                background: "#F4F6FB",
                border: "1px solid #E4E7EC",
              }}
            >
              <Typography
                variant="bodyHeavy"
                sx={{ fontWeight: 600, color: "#344054", mb: 0.5 }}
              >
                {k}
              </Typography>
              <Typography
                variant="body"
                sx={{ fontSize: "14px", color: "#6B6E7B" }}
              >
                <span style={{ fontWeight: 500 }}>From:</span>{" "}
                {eventData[k].match(regex)![1]} &rarr;{" "}
                <span style={{ fontWeight: 500 }}>To:</span>{" "}
                {eventData[k].match(regex)![2]}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
